import React from "react";
import {
  UserOutlined,
  FireOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

function Djal() {
  const data = [
    {
      title: "搭建基于工作流的Agent：今日英语单词（基于HiAgent）",
      content:
        "写作开头 AI 行业的终极目标是实现 AGI（通用人工智能），期望仅凭简单指令就能用媲美或超越人类的智力执行任何任务。然而，当前的大模型在处理多步骤复杂任务时仍存在明显局限。本文主要讨论工作流驱动的 Agent，搭建工作流驱动的 Agent“今日英语单词” ，简单情况可分为 3 个步骤： 规划：制定",
      time: "8月前",
      user: "Administrator",
      source: "搭建案例",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/wei-ming-ming-wen-zhang"
    },
    {
      title: "搭建多智能体模式的智能体：贵州旅游大师（基于HiAgent）",
      content:
        "一、设计 首先，让我们一起深入探索Agent开发平台上的多智能体模式设置。这个配置主要包括两个核心部分。第一部分是全局设置，涉及角色设定与回复逻辑及对话体验等全局性因素。第二部分则关注于多个代理之间的编排和协调。这两大设置共同构成了多智能体模式的详细框架。 那么，我们首先需要解决的问题是：在最左侧的",
      time: "8月前",
      user: "Administrator",
      source: "搭建案例",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/_4JzbPl.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/da-jian-hiagentduo-zhi-neng-ti-gui-zhou-lu-you-da-shi"
    },
  ];

  return (
    <>
      <div
        style={{
          maxHeight: "650px",
          overflow: "scroll",
        }}
      >
        {data && data.length
          ? data.map((item) => {
              return (
                <div className="listItemCon">
                  <div className="desContent">
                    <div className="title" style={{
                        cursor:"pointer"
                    }} onClick={() => {
                        window.open(item.url)
                    }}>{item.title}</div>
                    <div className="detail">{item.content}</div>
                    <div className="footer">
                      <span>
                        <span>
                          <ClockCircleOutlined />
                        </span>
                        <span>{item.time}</span>
                      </span>
                      <span>
                        <span>
                          <UserOutlined />
                        </span>
                        <span>{item.user}</span>
                      </span>
                      <span>
                        <span>
                          <FireOutlined />
                        </span>
                        <span>{item.agree}</span>
                      </span>
                    </div>
                  </div>
                  <div
                    className="image"
                    style={{
                      marginLeft: "20px",
                    }}
                  >
                    <img
                      style={{
                        width: "150px",
                        height: "100px",
                        borderRadius:"5px"
                      }}
                      src={item.icon}
                      alt=" "
                    />
                  </div>
                </div>
              );
            })
          : undefined}
      </div>
    </>
  );
}

export default Djal;
